import {
  CustomCollapseCard,
  CustomImage,
  CustomPagination,
  CustomTable,
  Text,
  useText
} from '@src/components';
import iconUser from '@src/assets/icons/icon-profil-user.svg';
import { useDispatch, useSelector } from 'react-redux';
import { formatPhoneNumber, moneyFormat } from '@src/utils/utils';
import iconChecked from '@src/assets/icons/icon-checked.svg';
import iconNoChecked from '@src/assets/icons/icon-no-check.svg';
import { useCallback, useEffect } from 'react';
import { cardOrderDetailsGelAll } from '@src/store/slice/cardOrderDetailtsSlice';
import { Tooltip } from 'antd';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';

const CardDetailInformation = () => {
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const { cardList, tableProperty } = useSelector((state) => state?.cardOrderDetails);
  const dispatch = useDispatch();

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: 70,
      render: (_, __, index) =>
        (tableProperty?.currentPage - 1) * tableProperty?.pageSize + index + 1,
    },
    {
      title: useText('nameUpperCase'),
      dataIndex: 'name',
      key: 'name',
      width: 142.7,
    },
    {
      title: useText('surnameUpperCase'),
      dataIndex: 'surname',
      key: 'surname',
      width: 140,
    },
    {
      title:
        currentCardOrder?.cardType === 1 ? (
          <>
            <Text t="gsmNoUpperCase" /><span className={'table-header-validation'}>*</span>
          </>
        ) : (
          <Text t="gsmNoUpperCase" />
        ),
      dataIndex: 'gsm',
      key: 'gsm',
      width: 160,
      align: 'center',
      render: (text) => <span>{text ? formatPhoneNumber(text) : ''}</span>,
    },
    {
      title: (
        <span>
          <Text t="referenceNumber2" />
          <Tooltip title={useText('thisIsTheNumberYouCanUseTo')}>
            {' '}
            <CustomImage src={iconInfo} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'refNo',
      key: 'refNo',
      width: 180,
      align: 'center',
    },
    {
      title: useText('address'),
      width: 152.7,
      dataIndex: 'addressText',
      key: 'addressText',
      align: 'center',
      render: (text) => <span style={{ textDecoration: 'underline' }}>{text}</span>,
    },
    {
      title: useText('price'),
      dataIndex: 'price',
      key: 'price',
      width: 100,
      align: 'right',
      render: (text) => <span>{text ? `${moneyFormat(text, false)}` : '0'}</span>,
    },
    {
      title: useText('mobilePayment'),
      dataIndex: 'mobilePaymentAuthorization',
      key: 'mobilePaymentAuthorization',
      width: 110,
      align: 'center',
      render: (text) =>
        text ? (
          <CustomImage
            style={{ paddingBottom: 10, paddingTop: 10 }}
            src={iconChecked}
            alt="check"
          />
        ) : (
          <CustomImage
            style={{ paddingBottom: 10, paddingTop: 10 }}
            src={iconNoChecked}
            alt="uncheck"
          />
        ),
    },
  ];

  useEffect(() => {
    (async () => {
      await dispatch(cardOrderDetailsGelAll({ pageNumber: 1, pageSize: 100000 }));
    })();
  }, [dispatch]);

  const handleTableChange = useCallback(
    async (pageNumber, pageSize) => {
      await dispatch(cardOrderDetailsGelAll({ pageNumber, pageSize }));
    },
    [dispatch],
  );

  return (
    <CustomCollapseCard
      cardTitle={<Text t="cardInformation2" />}
      cardTitleAlign="center"
      titleColor="#1d2228"
      titleSize="16px"
      showExpandIcon={false}
    >
      <CustomTable
        pagination={false}
        dataSource={cardList}
        columns={columns}
        rowKey={(record) => `card-summary-detail-list-${record?.id || record?.name}`}
      />

      <div className="compliment-person-information-table-footer" style={{ marginTop: 20 }}>
        <div className="d-flex">
          {/*<CustomPagination
            current={tableProperty?.currentPage}
            defaultCurrent={1}
            pageSize={tableProperty?.pageSize}
            total={tableProperty?.totalCount}
            onChange={async (pageNumber, pageSize) => {
              await handleTableChange(pageNumber, pageSize);
            }}
          />*/}
        </div>
        <div className="footer-info-container">
          <div className="footer-info-content">
            <CustomImage src={iconUser} />
            <div className="card-count-title">
              <Text t="numberOfCards3" />: <span>{currentCardOrder?.totalCount}</span>
            </div>
          </div>
          <div className="total-amount-title">
            <Text t="totalBalanceToBeLoadedUpperCaseColon" />
            <span>{moneyFormat(currentCardOrder?.totalPrice, true)}</span>
          </div>
        </div>
      </div>
    </CustomCollapseCard>
  );
};

export default CardDetailInformation;
